<template>
  <div>
    <div>
      <b-row>
        <b-col md="2">
          <b-form-group label="Type" label-for="type">
            <b-form-select v-model="filter.type" :options="type_options" />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group label="Variant" label-for="variant">
            <b-form-select v-model="filter.variant" :options="itemVariant" />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group label="Tier" label-for="tier">
            <b-form-select v-model="filter.tier" :options="itemLevel" />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-button @click="search" class="mt-0 mt-md-2 mr-1" variant="primary">
            Search
          </b-button>
        </b-col>
      </b-row>
    </div>
    <b-table-simple caption-top responsive bordered>
      <b-thead head-variant="light">
        <b-tr>
          <b-th class="text-center">STT</b-th>
          <b-th class="text-center">Type</b-th>
          <b-th class="text-center">Variant</b-th>
          <b-th class="text-center">Tier</b-th>
          <b-th class="text-center">Action</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <template v-for="(item, index) in items">
          <b-tr :key="item._id || index">
            <b-th class="text-center">{{ index + 1 }}</b-th>
            <b-th class="text-center"> {{ convertItemTypeName(item.type) }}</b-th>
            <b-th class="text-center"> {{ convertVariantName(item.type,item.variant,item.tier).variant.text }}</b-th>
            <b-th class="text-center"> {{ convertVariantName(item.type,item.variant,item.tier).tier.text }}</b-th>
            <b-th class="text-center">
              <div class="d-flex justify-content-center">
                <b-button
                variant="gradient-warning"
                style="margin-right: 5px"
                class="btn-icon"
                @click="editItem(item._id)"
              >
                <feather-icon icon="EditIcon" />
              </b-button>
              <b-button
                @click="confirmDelete(item._id)"
                variant="gradient-danger"
                class="btn-icon"
              >
                <feather-icon icon="Trash2Icon" />
              </b-button>
              </div>
            </b-th>
          </b-tr>
          
        </template>
      </b-tbody>
    </b-table-simple>
  </div>
</template>
<script>
import service from "../../service";
import config from "../../../items/config";
export default {
  props: {
    items: { type: Array, required: true },
  },
  data(){
    return{
      filter:{
      },
      type_options:[
        {text: "All", value: null},
        {text: "Clothes", value: "EQUIPMENT"},
        {text: "Smoothies", value: "CONSUMABLE"},
        // {text: "Box", value: "BOX"},
      ],
    }
  },
  computed:{
    itemVariant(){
      if (this.filter.type == "CONSUMABLE"){
        return config.SMOOTHY
      }
      if (this.filter.type == "EQUIPMENT"){
        return config.EQUIPMENT
      }
      if (this.filter.type == "BOX"){
        return null
      }
      return null
    },
    itemLevel(){
      if (this.itemVariant && this.filter.variant){
        let variant = this.itemVariant.find((x)=>{
          return x.value == this.filter.variant
        })
        return variant ? variant.tier : null
      }
      return null
    }
  },
  methods: {
    confirmDelete(id) {
      this.$bvModal
        .msgBoxConfirm("Are you sure ?", {
          title: "Please Confirm",
          size: "md",
          okVariant: "danger",
          okTitle: "Yes",
          cancelTitle: "No",
          cancelVariant: "outline-secondary",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value === true) {
            this.deleteItem(id);
          }
        });
    },
    async deleteItem(id) {
      await service.delete({ id: id });
      this.$emit("getList");
    },
    editItem(id) {
      this.$router.push({
        name: "items-class-detail",
        params: { item_id: id },
      });
    },
    convertItemTypeName(value){
      if(value == "EQUIPMENT"){
        return "CLOTHES"
      }
      else if(value == "CONSUMABLE"){
        return "SMOOTHY"
      }
      else{
        return value
      }
    },
    convertVariantName(type, variant, tier){
      return config.convertVariantName(type, variant, tier)
    },
    search(){
      for (var propName in this.filter) {
        if (this.filter[propName] === null || this.filter[propName] === undefined) {
          delete this.filter[propName];
        }
      }
      this.$emit("getList", this.filter)
    }
  },
};
</script>
<style scoped>
  .item-thumbnail{
    width: 70% !important;
    height: 50% !important;
  }
</style>
